<top-nav-bar [navTitle]="'dashboard' | localize" [topNavBarButtonsConfig]="topNavBarButtonsConfig" [isGrayBackground]="true" searchFacet="everywhere" />
